import {Component, ElementRef, EventEmitter, Output, QueryList, ViewChildren} from '@angular/core';

@Component({
  selector: 'app-otp',
  standalone: false,
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss'
})
export class OtpComponent {
  boxes = Array(6).fill(0);
  otp: string[] = Array(6).fill('');
  @ViewChildren('otpBox') inputs!: QueryList<ElementRef<HTMLInputElement>>;
  @Output() codeChange = new EventEmitter<string>();

  onInput(event: Event, i: number) {
    const input = event.target as HTMLInputElement;
    const digit = (input.value || '').replace(/\D/g, '').slice(0, 1);
    this.otp[i] = digit;
    input.value = digit;
    if (digit && i < this.boxes.length - 1) {
      this.focusIndex(i + 1);
    }
    this.emitCode();
  }

  onKeydown(event: KeyboardEvent, i: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Backspace') {
      if (!input.value && i > 0) {
        this.focusIndex(i - 1);
      } else {
        this.otp[i] = '';
        input.value = '';
      }
      event.preventDefault();
      this.emitCode();
      return;
    }
    if (event.key === 'ArrowLeft' && i > 0) {
      this.focusIndex(i - 1);
      event.preventDefault();
      return;
    }
    if (event.key === 'ArrowRight' && i < this.boxes.length - 1) {
      this.focusIndex(i + 1);
      event.preventDefault();
      return;
    }
    if (event.key.length === 1 && !/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent, i: number) {
    event.preventDefault();
    const data = event.clipboardData?.getData('text') ?? '';
    const digits = data.replace(/\D/g, '').slice(0, this.boxes.length - i);
    if (!digits) return;
    for (let k = 0; k < digits.length; k++) {
      const idx = i + k;
      if (idx >= this.boxes.length) break;
      this.otp[idx] = digits[k];
      const el = this.inputs.get(idx)?.nativeElement;
      if (el) el.value = digits[k];
    }
    const last = Math.min(i + digits.length, this.boxes.length - 1);
    this.focusIndex(last);
    this.emitCode();
  }

  public clear() {
    this.otp.fill('');
    this.inputs.forEach((ref) => (ref.nativeElement.value = ''));
    this.focusIndex(0);
    this.emitCode();
  }

  public value(): string {
    return this.otp.join('');
  }

  private emitCode() {
    this.codeChange.emit(this.otp.join(''));
  }

  private focusIndex(idx: number) {
    const el = this.inputs.get(idx)?.nativeElement;
    el?.focus();
    el?.select();
  }
}
